<template>
  <div class="layout-wrapper">
    <sidebar></sidebar>
    <main class="main-content-area">
      <section class="screen-section">
        🎉 Go Pro with Kaelu – Your Brainy Sidekick Just Leveled Up! 🧠✨

        <p>
          Think Kaelu’s smart now? Just wait ‘til you meet Kaelu Pro — the glow-up your workflow didn’t know it needed.
        </p>

        <p>
          With Kaelu Pro, you get:
        </p>

        <ul>
          <li>💬 Unlimited conversations (chat away, no limits!)</li>
          <li>🎨 Unlimited image generation – get visual, get creative</li>
          <li>📎 Upload images directly into the chat for richer interactions</li>
          <li>🤖 Multiple specialised chatbots tailored to your profession</li>
          <li>🚀 Early access to new features – be the first to try what’s next</li>
          <li>🧠 Advanced AI models that are faster, sharper, and better at handling the complex stuff</li>
        </ul>

        <p>Whether you're diagnosing data, drafting legal docs, or untangling a financial mess — Kaelu Pro’s got your back.</p>
        <p>Smarter tools, deeper insights, no limits.</p>
        <p>Upgrade to Kaelu Pro today. Let the brilliance begin.</p>

        <button @click="subscribeToPlan" :disabled="sub.loading" class="btn bg-blue-500 text-white p-2 rounded">
          <span class="material-symbols-rounded">workspace_premium</span>
          <span class="btn-text">Upgrade to Pro</span>
        </button>

        <p v-if="sub.error" class="text-red-500">{{ sub.error }}</p>

      </section>
    </main>
  </div>
</template>

<script setup>
import Sidebar from "@/components/Sidebar.vue";
import {useAuthStore} from "@/stores/auth.js";

const loading = ref(false);
const authStore = useAuthStore();
const user = authStore.getUser();

const upgradePlan = () => {
  authStore.upgradePlan();
};
import { useSubscriptionStore } from '@/stores/subscription'

const sub = useSubscriptionStore()

const priceId = 'price_1RdFjOJgZjkxO39avMdG4EjS';
const userEmail = authStore.getUser().email;

const subscribeToPlan = () => {
  sub.subscribe(priceId, userEmail)
}
</script>
